declare const window: any

export function isEditing(){
    return window && window.wp && window.wp.editor;
}
